import  gql  from 'graphql-tag'

export const SHARE_WORKSHEET_EMAIL = gql`mutation shareWorksheetByEmail($input: ShareWorksheetByEmailMutationInput!){
    shareWorksheetByEmail(input: $input){
        errors{
            field
            messages
        }
    }
}`;